import React from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  CircularProgress,
  Autocomplete,
  TextField,
  Grid,
} from "@material-ui/core";
import { Backdrop } from "@material-ui/core";



const ChangeUserPopUp = ({
  open,
  close,
  submit,
//   attachInvoiceLoading,
autocompleteChangeHandler,
rolesLoading,
filteredUserData,
  selectedUser,
  comment,
  changeCommentHandler
}) => {

  return (
    <Dialog open={open} onClose={close} fullWidth={true}>
      <DialogContent>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        //   open={attachInvoiceLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
            <Grid  item xs={12} lg={6} sm={12} md={6} sx= {{  textAlign: "center", justifyContent:"center"}}>
           <h2>Change User </h2>
              <Grid mb={4}>
              <Typography>
              <span style= {{color:"red"}}>
                  *
                </span>
                Select User:</Typography>
              <Autocomplete
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInputBase-input": {
                    marginTop: "-4px", // Adjust this value to move the text up
                    fontSize: 15,
                  },
                }}
                size="small"
                id="User"
                options={filteredUserData}
                name="User"
                getOptionLabel={(option) =>
                  option !== "" && `${option?.userName}`
                }
                loading={rolesLoading}
                onChange={(event, newValue) => {
                  autocompleteChangeHandler("User", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name=""
                    required
                    value={""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}></TextField>
                )}></Autocomplete>
              </Grid>
              <Grid>
              <Typography style={{ color: "black" }}>
                <span style= {{color:"red"}}>
                  *
                </span>
                         Comments:
                        {/* <span className={classes.asterisk}>*</span> */}
                      </Typography>
                      <TextField
                        fullWidth
                        multiline
                        name="aditional_Comments"
                        value={comment}
                        onChange={(e) => {
                          changeCommentHandler("Comment", e.target.value);
                        }}
                        // rows={2}
                        maxRows={4}
                        // size="small"
                        sx={{
                          // width: "70%",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        // disabled={disable}
                        required
                      />
              </Grid>
                
            </Grid>



           
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
          p={2}
          mt={1}
        >
          
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
          m={1}
        >
          
          <Button
            variant="contained"
            color="secondary"
            onClick={submit}
            style={{ marginLeft: "20px" }}
            disabled = {selectedUser === "" || selectedUser === undefined || comment == "" || comment == undefined}
          >
            Change
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ChangeUserPopUp;
